class ErrorPointsNotOnPlane extends Error {
    constructor(message) {
        super(message);
        this.name = 'ErrorPointsNotOnPlane';
    }
}

export { ErrorPointsNotOnPlane };